"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAct = addAct;
exports.exportData = exportData;
exports.getActList = getActList;
exports.getCouponByThirdId = getCouponByThirdId;
exports.getDetail = getDetail;
exports.getInventoryList = getInventoryList;
exports.getJoinList = getJoinList;
exports.getUserList = getUserList;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getActList(params) {
  return (0, _requestPIM.default)({
    url: '/xyCouponExpand/page',
    method: 'get',
    params: params
  });
}
function getJoinList(params) {
  return (0, _requestPIM.default)({
    url: '/xyCouponExpandParticipate/page',
    method: 'get',
    params: params
  });
}
function getUserList(params) {
  return (0, _requestPIM.default)({
    url: '/xyCouponExpandRelation/page',
    method: 'get',
    params: params
  });
}
function getInventoryList(params) {
  return (0, _requestPIM.default)({
    url: 'xyCouponExpandInventory/page',
    method: 'get',
    params: params
  });
}
function addAct(data) {
  return (0, _requestPIM.default)({
    url: '/xyCouponExpand/saveOrUpdate',
    method: 'post',
    data: data
  });
}
function getDetail(id) {
  return (0, _requestPIM.default)({
    url: '/xyCouponExpand/' + id,
    method: 'get'
  });
}

// 根据券第三方id获取券
function getCouponByThirdId(id) {
  return (0, _requestPIM.default)({
    url: '/xyCouponExpand/getCouponByThirdId?id=' + id,
    method: 'get'
  });
}

// 导出
function exportData(params) {
  return (0, _requestPIM.default)({
    url: '/xyCouponExpandParticipate/exportList',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}